import { UtmSource, UtmTags } from 'core/user/entities';

export const POSSIBLE_UTM_TAGS: Array<keyof UtmTags> = [
  'utm_source',
  'utm_medium',
  'utm_content',
  'utm_term',
  'utm_campaign_id',
  'utm_campaignid',
  'utm_campaign',
  'utm_adset_id',
  'utm_adsetid',
  'utm_adset',
  'utm_ad_id',
  'utm_adid',
  'utm_ad',
  'gclid',
  'gbraid',
  'iterable_message_id',
  'fbp',
  'fbc',
  'fbclid',
  'ga',
  'everflow_transaction_id',
  'utm_source_retention',
  'utm_adset_name',
  'utm_placement',
  'utm_ad_name',
  'ttclid',
  'quizz',
  'oid',
  '_ef_transaction_id',
  'ad_group',
  'fb_test_event_code',
  'tt_test_event_code',
  'seo_channel',
  'seo_landing_page',
  'seo_referrer',
  'utm_emailuser',
  'delivery_id',
];

export const UTM_TAGS_WITH_PROHIBITED_WORDS_CHECK = [
  'utm_campaign',
  'utm_ad',
  'utm_adset',
] as const;

export const UTM_TAGS_MONITORING_ERROR_REASON_TAG = 'prohibited_words_in_utm_tags';

export const PROHIBITED_WORDS_IN_UTM_TAGS = [
  'depression',
  'blood',
  'pressure',
  'diabetes',
  'cancer',
  'hiv',
  'alzheimer',
  'asthma',
  'epilepsy',
  'eczema',
  'anxiety',
  'psycho',
  'therapy',
  'appendicitis',
  'stress',
  'bipolar',
  'disorder',
  'glucose',
  'insulin',
  'fitness',
  'surgery',
  'chemo',
  'radiation',
  'dialysis',
  'antidepressants',
  'medication',
  'drugs',
  'antipsychotics',
  'sleep',
  'hormone',
  'temperature',
  'digestion',
  'cardiac',
  'clinic',
  'fertility',
  'center',
  'mental',
  'health',
  'rehabilitation',
  'trauma',
  'addiction',
  'alcohol',
] as const;

export interface UtmTagsService {
  getUtmTags: () => Partial<UtmTags>;

  getUtmSource: () => UtmSource;

  getUtmAdName: () => string;

  getUtmContent: () => string;

  updateUtmTags: (utmTags: UtmTags) => UtmTags;
}
